import { render, staticRenderFns } from "./AccountSettingSportM8.vue?vue&type=template&id=16960488&"
import script from "./AccountSettingSportM8.vue?vue&type=script&lang=js&"
export * from "./AccountSettingSportM8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports